var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quick-menu',{staticClass:"burgerMenu",attrs:{"menu-count":_vm.menu.menuCount,"menu-url-list":_vm.menu.menuUrlList,"icon-class":_vm.menu.iconClass,"position":_vm.menu.position,"backgroundColor":_vm.menu.backgroundColor,"color":_vm.menu.color,"isOpenNewTab":_vm.menu.isOpenNewTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }